export default function delay(ms) {
    return new Promise((result) => setTimeout(result, ms));
}
